export default {
  words: [
    "absurd",
    "accomplish",
    "advantageous",
    "ancient",
    "anxious",
    "astonishment",
    "bewilder",
    "blunder",
    "cautious",
    "competition",
    "disappear",
    "durability",
    "elation",
    "evidence",
    "exaggerate",
    "feasible",
    "genre",
    "grumble",
    "hazardous",
    "hesitate",
    "immediate",
    "impair",
    "implement",
    "initiate",
    "meddlesome",
    "medieval",
    "mischief",
    "monarch",
    "narrator",
    "necessaryy",
    "occasion",
    "pedestrian",
    "perish",
    "punctual",
    "receipt",
    "rhythm",
    "scatter",
    "servant",
    "solitary",
    "tremble"
  ],
  stats: {}
};
